/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './close-account.module';
export * from './components/close-account-modal/close-account-modal.component';
export * from './components/close-account/close-account.component';
